import {forwardRef} from 'react';
import {Input as AntdInput} from 'antd';

const Input = forwardRef((props, ref) => (
  <AntdInput
    ref={ref}
    {...props}
  />
));
Input.TextArea = AntdInput.TextArea;
Input.Group = AntdInput.Group;
Input.Search = AntdInput.Search;
export default Input;
